module.exports = __webpack_public_path__ + "img/dataShow.0e2b12f4.png";